import { SEND_INVITE_REQUEST, SEND_INVITE_SUCCESS, SEND_INVITE_FAILURE } from './actionTypes'
import { selectClientId } from '../store/selectors/client'
import { flashNotification } from './notification'
import { SHARE, ERRORS } from '../constants/messages'
import { createClientInviteEmail } from '../api/mikasa/requests'

export const sendInvite =
  ({ firstName, lastName, email }, createReferralInviteClientEvent) =>
  async (dispatch, getState) => {
    const state = getState()
    const clientId = selectClientId(state)

    dispatch({
      type: SEND_INVITE_REQUEST
    })

    try {
      await createClientInviteEmail({
        email,
        firstName,
        clientId,
        lastName
      })

      dispatch({
        type: SEND_INVITE_SUCCESS
      })
      if (createReferralInviteClientEvent) {
        createReferralInviteClientEvent()
      }
      dispatch(
        flashNotification({
          message: SHARE.success,
          messageType: 'success'
        })
      )
    } catch (error) {
      dispatch({
        type: SEND_INVITE_FAILURE,
        error
      })

      dispatch(
        flashNotification({
          message: [ERRORS.defaultHeadline, ERRORS.defaultMessage],
          messageType: 'error'
        })
      )
    }
  }
